module.exports = __webpack_public_path__ + "img/clip.240ea0fd.svg";